import createClient from "openapi-fetch";
import type { paths } from "../../../__definitions__/communication.changeengine.com-definitions";
import { serviceURL } from "../../../utils/service-url";

export const showroomClient = createClient<paths>({
  baseUrl: serviceURL("showroom"),
  headers: { "Content-Type": "application/json" },
});
